"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = exports.Row = exports.GridContainer = exports.FlexSection = exports.Flex = exports.Container = exports.Box = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _styled = require("../../util/styled");
const _excluded = ["spacing", "childSpacing", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const Box = exports.Box = (0, _styled.withTheme)(_styledComponents.default.div`
  position: relative;
  cursor: default;
  text-align: ${props => props.align || 'left'};
  ${_styled.bg};
  ${_styled.space};
  ${_styled.minHeight};
  ${_styled.minWidth};
  ${_styled.width};
  ${_styled.display};
  ${_styled.shadow};
`);
Box.displayName = 'Box';
const Flex = exports.Flex = (0, _styled.withTheme)(_styledComponents.default.div`
  display: flex;
  height: ${props => props.height || 'auto'};
  flex-direction: ${props => props.direction || 'column'};
  justify-content: ${props => props.justify || 'center'};
  align-items: ${props => props.align || 'center'};
  flex-wrap: ${props => props.wrap === 'true' ? 'wrap' : 'nowrap'};
  ${_styled.space};
`);
Flex.displayName = 'Flex';
Flex.propTypes = {
  wrap: _propTypes.default.string
};
Flex.defaultProps = {
  wrap: 'false'
};
const Row = exports.Row = _styledComponents.default.div`
  ${_styled.space};
  ${_styled.minHeight};
`;
Row.displayName = 'Row';
const Container = exports.Container = _styledComponents.default.div`
  -webkit-font-smoothing: subpixel-antialiased;
  padding: 10px;
  &:after {
    content: '';
    display: block;
    clear: both;
  }
  ${_styled.space};
`;
Container.displayName = 'Container';
const Section = exports.Section = _styledComponents.default.div`
  background-color: #fff;
  padding: 20px;
  ${_styled.space};
`;
Section.displayName = 'Section';
const FlexSection = exports.FlexSection = (0, _styledComponents.default)(Section)`
  display: flex;
  justify-content: center;
  ${_styled.space};
`;
FlexSection.displayName = 'FlexSection';

/**
 * Returns a grid item for react child
 * @param  { breakpoint: number }[] Spacing Value -
 * Array of objects that define the spacing for each child value
 * e.g. [ {xl : 12} ] SEE: https://material-ui.com/api/grid/
 * @param {spacing} - Defines the spacing in between each child.
 * Defaults to 16. See the material-ui grid api
 */
const GridContainer = exports.GridContainer = (0, _styled.withTheme)(_ref => {
  let {
      spacing = 16,
      childSpacing = [],
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Grid.default, _extends({
    container: true,
    spacing: spacing
  }, rest), _react.default.Children.map(children, (child, i) => {
    return /*#__PURE__*/_react.default.createElement(_Grid.default, _extends({
      item: true
    }, childSpacing[i]), child);
  }));
});
GridContainer.displayName = 'GridContainer';
//# sourceMappingURL=Containers.js.map